/**
 * @hidden
 */
export function hasListener(eventName) {
    if (this.v3) {
        var eventInAttrs = Object.keys(this.$attrs).map(function (name) { return name.toLowerCase(); })
            .some(function (event) { return event.endsWith(eventName.toLowerCase()); });
        var eventInProps = Object.entries(this.$props)
            .some(function (_a) {
            var name = _a[0], value = _a[1];
            var event = name.toLowerCase();
            return value !== undefined && event.startsWith('on') && event.endsWith(eventName.toLowerCase());
        });
        return eventInAttrs || eventInProps;
    }
    else {
        return this.$listeners[eventName];
    }
}
/**
 * @hidden
 */
export function getListeners() {
    if (this.v3) {
        var listeners = {};
        for (var key in (this.$attrs)) {
            if (key.startsWith('on')) {
                listeners[key] = this.$attrs[key];
            }
        }
        for (var key in (this.$props)) {
            if (key.startsWith('on')) {
                listeners[key] = this.$props[key];
            }
        }
        return listeners;
    }
    else {
        return this.$listeners;
    }
}
